import { WHITEPAPER_CONTACT_ENDPOINT } from '@/constants/endpoints'

export default {
  methods: {
    async sendWhitepaperContactForm (data) {
      const params = new URLSearchParams()
      try {
        await this.$axios.$post(WHITEPAPER_CONTACT_ENDPOINT, data, { params })
      } catch (e) {
        return
      }
      return true
    }
  }
}
